<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Como nos has conocido</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-col cols="12">
                            <router-link to="lista-clientes-conocido">
                                <v-btn color="red" class="white--text" s>
                                    Volver
                                </v-btn>
                            </router-link>
                        </v-col>
                        <form ref="form">
                            <input
                                :value="$route.query.id"
                                v-if="$route.query.id != null"
                                name="id"
                                style="display: none"
                            />
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-text-field
                                        v-model="producto.nombre"
                                        label="Nombre"
                                        name="nombre"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </form>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-clientes-conocido">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!producto.id"
                                    @click="saveClienteConocido"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id"
                                    @click="updateClienteConocido"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id"
                                    @click="
                                        isDeleteClienteConocidoDialogVisible = true
                                    "
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            familia.id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteFamilia()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear/Editar Familia
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-text-field
                        v-model="familia.nombre"
                        label="Nombre"
                        required
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            familia.id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn
                        v-if="familia.id"
                        color="success"
                        large
                        @click="updateFamilia()"
                        >Modificar</v-btn
                    >
                    <v-btn v-else color="success" large @click="createFamilia()"
                        >Guardar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialog
            v-model="isDeleteClienteConocidoDialogVisible"
            @delete="deleteClienteConocido"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
export default {
    components: {
        DeleteDialog,
    },
    data() {
        return {
            isDeleteClienteConocidoDialogVisible: false,
            imagen: null,
            menu: false,
            dialog: false,
            canal: {
                id: null,
                nombre: null,
            },
            delete_dialog: false,
            producto: {
                id: null,
                precio: "",
                idFamilia: -1,
                id_canal: null,
            },
            familias: [],
            familia: {
                id: null,
                nombre: "",
            },
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.$route.query.id) {
            this.getClienteConocido(this.$route.query.id);
        }
    },
    methods: {
        getClienteConocido(producto_id) {
            axios.get(`api/get-cliente-conocido/${producto_id}`).then(
                (res) => {
                    this.producto = res.data;
                },
                (res) => {}
            );
        },
        updateClienteConocido() {
            let data = new FormData(this.$refs.form);
            axios
                .post("api/save-cliente-conocido", data)
                .then((res) => {
                    this.$router.push("lista-clientes-conocido");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salio mal");
                    }
                });
        },
        saveClienteConocido() {
            axios
                .post("api/save-cliente-conocido", this.producto)
                .then((res) => {
                    this.$router.push("lista-clientes-conocido");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salio mal");
                    }
                });
        },
        deleteClienteConocido() {
            axios
                .post("api/delete-cliente-conocido", { id: this.producto.id })
                .then(
                    (res) => {
                        this.isDeleteClienteConocidoDialogVisible = false;
                        this.$router.push("lista-clientes-conocido");
                    },
                    (res) => {}
                );
        },
        save(date) {
            this.$refs.menu.save(date);
        },

        openDeleteDialog(id) {
            this.familia.id = id;
            this.delete_dialog = true;
        },
        openDialog() {
            this.familia.id = null;
            this.familia.nombre = "";
            this.dialog = true;
        },
        openEditDialog(id, nombre) {
            this.familia.id = id;
            this.familia.nombre = nombre;
            this.dialog = true;
        },
    },
    filters: {},

    computed: {
        getImage() {
            if (this.imagen != null) {
                return URL.createObjectURL(this.imagen);
            } else {
                return `api/getproducto-image/${this.$route.query.id}`;
            }
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        canales() {
            return this.$store.getters.getcanales;
        },
    },
};
</script>
